"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// This line simply evaluates the file
// and applies Big.js extensions to the source prototype.
require("./extensions");
const big_js_1 = __importDefault(require("big.js"));
const constructor_1 = __importDefault(require("./constructor"));
Object.assign(constructor_1.default, big_js_1.default);
Object.setPrototypeOf(constructor_1.default, big_js_1.default.prototype);
Object.defineProperty(constructor_1.default, 'DP', {
    set: (value) => (big_js_1.default.DP = value),
    get: () => big_js_1.default.DP,
});
Object.defineProperty(constructor_1.default, 'RM', {
    set: (value) => (big_js_1.default.RM = value),
    get: () => big_js_1.default.RM,
});
Object.defineProperty(constructor_1.default, 'NE', {
    set: (value) => (big_js_1.default.NE = value),
    get: () => big_js_1.default.NE,
});
Object.defineProperty(constructor_1.default, 'PE', {
    set: (value) => (big_js_1.default.PE = value),
    get: () => big_js_1.default.PE,
});
Object.defineProperty(constructor_1.default, 'strict', {
    set: (value) => (big_js_1.default.strict = value),
    get: () => big_js_1.default.strict,
});
Object.defineProperty(constructor_1.default, Symbol.hasInstance, {
    value(instance) {
        return instance instanceof big_js_1.default;
    },
});
// Default Big Settings
big_js_1.default.RM = big_js_1.default.roundDown;
// Export the constructor const and type under the same name to "merge" them for consumers
const Big = constructor_1.default;
exports.default = Big;
//# sourceMappingURL=index.js.map